import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Team = () => {
  useEffect(() => {
    // Initialize Swiper for leadership team
    if (window.Swiper) {
      const leadershipConfig = {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 4000
        },
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.leadership-slider .swiper-pagination',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        }
      };

      const leadershipSwiper = document.querySelector('.leadership-slider.init-swiper');
      if (leadershipSwiper && !leadershipSwiper.swiper) {
        new window.Swiper(leadershipSwiper, leadershipConfig);
      }
    }
  }, []);

  const teamMembers = [
    {
      name: 'Sarah Chen',
      role: 'Creative Director',
      image: '/images/person-f-3.webp',
      social: [
        { icon: 'bi-linkedin', url: '#' },
        { icon: 'bi-twitter', url: '#' }
      ]
    },
    {
      name: 'Marcus Johnson',
      role: 'Tech Lead',
      image: '/images/person-m-4.webp',
      social: [
        { icon: 'bi-github', url: '#' },
        { icon: 'bi-linkedin', url: '#' }
      ]
    },
    {
      name: 'Emma Rodriguez',
      role: 'Product Manager',
      image: '/images/person-f-8.webp',
      social: [
        { icon: 'bi-instagram', url: '#' },
        { icon: 'bi-dribbble', url: '#' }
      ]
    },
    {
      name: 'David Kim',
      role: 'UX Architect',
      image: '/images/person-m-6.webp',
      social: [
        { icon: 'bi-behance', url: '#' },
        { icon: 'bi-linkedin', url: '#' }
      ]
    }
  ];

  const leaders = [
    {
      name: 'Jennifer Walsh',
      position: 'Chief Executive Officer',
      image: '/images/person-f-14.webp',
      description: 'Former VP of Engineering at a Fortune 500 SaaS company. Focused on building long-term client partnerships and scalable delivery practices.',
      contact: [
        { icon: 'bi-envelope', url: '#' },
        { icon: 'bi-linkedin', url: '#' }
      ]
    },
    {
      name: 'Robert Martinez',
      position: 'Chief Technology Officer',
      image: '/images/person-m-13.webp',
      description: '15+ years in software architecture and cloud platforms. AWS and Azure certified, passionate about clean architecture and DevOps.',
      contact: [
        { icon: 'bi-envelope', url: '#' },
        { icon: 'bi-github', url: '#' }
      ]
    },
    {
      name: 'Lisa Thompson',
      position: 'Head of Operations',
      image: '/images/person-f-5.webp',
      description: 'Leads delivery, resource planning, and quality assurance. Ensures every project has clear milestones and predictable outcomes.',
      contact: [
        { icon: 'bi-envelope', url: '#' },
        { icon: 'bi-twitter', url: '#' }
      ]
    },
    {
      name: 'Alex Garcia',
      position: 'VP of Engineering',
      image: '/images/person-m-9.webp',
      description: 'Heads our engineering practices and hiring. Former principal engineer at major tech firms, expert in distributed systems and APIs.',
      contact: [
        { icon: 'bi-envelope', url: '#' },
        { icon: 'bi-linkedin', url: '#' }
      ]
    }
  ];

  return (
    <section id="team" className="team section">


      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="team-intro" data-aos="fade-right" data-aos-delay="150">
              <div className="intro-content">
                <h3>Meet Our Exceptional Team</h3>
                <p>Our team brings deep expertise in full-stack development, cloud platforms, and agile delivery. We work as an extension of your organization to ship quality software on time.</p>
                <div className="stats-row">
                  <div className="stat-item">
                    <span className="stat-number">50+</span>
                    <span className="stat-label">Team Members</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">8</span>
                    <span className="stat-label">Departments</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">15+</span>
                    <span className="stat-label">Countries</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="team-grid" data-aos="fade-left" data-aos-delay="200">
              {teamMembers.map((member, index) => (
                <div key={index} className="member-hexagon" data-aos="zoom-in" data-aos-delay={250 + (index * 50)}>
                  <div className="hexagon-inner">
                    <img src={member.image} alt={member.name} />
                    <div className="member-overlay">
                      <h5>{member.name}</h5>
                      <span>{member.role}</span>
                      <div className="social-icons">
                        {member.social.map((social, idx) => (
                          <a key={idx} href={social.url}><i className={`bi ${social.icon}`}></i></a>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-12">
            <div className="team-carousel-wrapper" data-aos="fade-up" data-aos-delay="200">
              <h4 className="carousel-title">Leadership Team</h4>

              <div className="leadership-slider swiper init-swiper">
                <div className="swiper-wrapper">
                  {leaders.map((leader, index) => (
                    <div key={index} className="swiper-slide">
                      <div className="leader-card">
                        <div className="leader-image">
                          <img src={leader.image} alt={leader.name} />
                        </div>
                        <div className="leader-info">
                          <h5>{leader.name}</h5>
                          <span className="position">{leader.position}</span>
                          <p>{leader.description}</p>
                          <div className="leader-contact">
                            {leader.contact.map((contact, idx) => (
                              <a key={idx} href={contact.url} className="contact-btn">
                                <i className={`bi ${contact.icon}`}></i>
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-8 offset-lg-2">
            <div className="join-team-cta" data-aos="fade-up" data-aos-delay="300">
              <div className="cta-icon">
                <i className="bi bi-rocket-takeoff"></i>
              </div>
              <div className="cta-content">
                <h4>Ready to Join Our Team?</h4>
                <p>We're always looking for strong engineers and consultants who care about quality, collaboration, and continuous learning.</p>
                <div className="cta-actions">
                  <Link to="/contact" className="btn btn-primary">View Open Roles</Link>
                  <Link to="/about" className="btn btn-outline">Learn About Us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
